/** Protected result derivatives stay on the authenticated API and outside resource caches. */
export function outputVariantPath(filePath: string, variant: 'thumbnail' | 'preview' | 'original'): string {
  if (/^\/api\/files\/outputs\/[0-9a-f-]+\/versions\/[0-9a-f-]+\/(original|preview|thumbnail)$/i.test(filePath)) {
    return filePath.replace(/\/(original|preview|thumbnail)$/, `/${variant}`);
  }
  if (/^\/api\/files\/outputs\/[0-9a-f-]+(?:\?variant=(?:thumbnail|preview|original))?$/i.test(filePath)) {
    return `${filePath.split('?')[0]}?variant=${variant}`;
  }
  return filePath;
}
